module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/digital-realities.json
// module id = 432
// module chunks = 125868233959201